import React from "react";

const stuffContent = [
  {name: "Szebedinszky Péter",img: "Szebedinszky-Peter-uj.jpg" },
  {name: "Pintér Gábor",img: "Pinter-Gabor.jpg" },
  {name: "Barna László",img: "Barna-Laszlo.jpg" },
  {name: "Arányi Balázs",img: "Aranyi-Balazs.jpg" },
  {name: "Aszódi Beáta",img: "Aszodi-Beata.jpg" },
  {name: "Balla László",img: "Balla-Laszlo.jpg" },
  {name: "Barna-Nagy Ágnes",img: "Barna-Nagy-Agnes.jpg" },
  {name: "Fabó Csenge",img: "Fabo-Csenge.jpg" },
  {name: "Gunda Gabriella",img: "Gunda_Gabriella.jpg" },
  {name: "Maginyecz-Izbéki Kitty",img: "Izbeki-Kitti.jpg" },
  {name: "Németh-Szabó Szilvia",img: "Nemeth-Szabo-Szilvia.jpg" },
  {name: "Némethné S. Adrienn",img: "Nemethne-Adrienn.jpg" },
  {name: "Szebedinszky-Csernus Olga",img: "Szebedinszky-Olga.jpg" },
  {name: "Szűcsné Bertalan Enikő",img: "Szucsne-Bertalan-Eniko.jpg" },
  {name: "Varga Ildikó",img: "Varga-Ildiko.jpg" },
  {name: "Vigh Donát",img: "Vigh-Donath.jpg" },
];


const StuffEn = () => {
  return (
    <div className="col-12">
      <div className="row">
      
    
   
      {stuffContent.map((val, i) => (
    
          <div  className="col-2 mr-2  d-none  d-lg-block stuff-padding">
          <img
              src={`img/stuff/${val.img}`}
              className="img-fluid main-img-stuff d-sm-block "
              alt={`${val.name}`}
            />
            <h6 class="poppins-font text-uppercase text-center"> {val.name} </h6>
            </div>
           
          
         
      ))}
          {stuffContent.map((val, i) => (
    
    <div  className="col-4 d-lg-none stuff-padding">
    <img
        src={`img/stuff/${val.img}`}
        className="img-fluid main-img-stuff d-sm-block "
        alt="hero man"
      />
      <h6 class="poppins-font text-uppercase text-center  collegak"> {val.name} </h6>
      </div>
     
    
   
))}
    </div>
    </div>
  );
};

export default StuffEn;
